import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IScheduling } from 'app/shared/model/scheduling.model';
import { getEntities as getSchedulings } from 'app/entities/scheduling/scheduling.reducer';
import { getEntity, updateEntity, createEntity, reset } from './scheduling-history.reducer';
import { ISchedulingHistory } from 'app/shared/model/scheduling-history.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const SchedulingHistoryUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const schedulings = useAppSelector(state => state.scheduling.entities);
  const schedulingHistoryEntity = useAppSelector(state => state.schedulingHistory.entity);
  const loading = useAppSelector(state => state.schedulingHistory.loading);
  const updating = useAppSelector(state => state.schedulingHistory.updating);
  const updateSuccess = useAppSelector(state => state.schedulingHistory.updateSuccess);

  const handleClose = () => {
    props.history.push('/scheduling-history' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getSchedulings({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.created = convertDateTimeToServer(values.created);

    const entity = {
      ...schedulingHistoryEntity,
      ...values,
      scheduling: schedulings.find(it => it.id.toString() === values.schedulingId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          created: displayDefaultDateTime(),
        }
      : {
          ...schedulingHistoryEntity,
          created: convertDateTimeFromServer(schedulingHistoryEntity.created),
          schedulingId: schedulingHistoryEntity?.scheduling?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.schedulingHistory.home.createOrEditLabel" data-cy="SchedulingHistoryCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.schedulingHistory.home.createOrEditLabel">Create or edit a SchedulingHistory</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField name="id" required readOnly id="scheduling-history-id" label={translate('global.field.id')} validate={{ required: true }} />
              ) : null}
              <ValidatedField
                label={translate('fleetSenseApp.schedulingHistory.created')}
                id="scheduling-history-created"
                name="created"
                data-cy="created"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                id="scheduling-history-scheduling"
                name="schedulingId"
                data-cy="scheduling"
                label={translate('fleetSenseApp.schedulingHistory.scheduling')}
                type="select"
              >
                <option value="" key="0" />
                {schedulings
                  ? schedulings.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/scheduling-history" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};
